import script from "./SummaryBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryBlock.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryBlock.vue?vue&type=style&index=0&id=6068ca7a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6068ca7a"]])

export default __exports__